import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import About from "@/pages/About";
import HowItWorks from "@/pages/HowItWorks";
import Performance from "@/pages/Performance";
import Contact from "@/pages/Contact";
import VerticalPage from "@/pages/VerticalPage";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import CCPA from "@/pages/CCPA";
import CaseStudiesIndex from "@/pages/CaseStudiesIndex";
import CaseStudyPage from "@/pages/CaseStudyPage";
import BlogIndex from "@/pages/BlogIndex";
import BlogPost from "@/pages/BlogPost";

function App() {
  return (
    <div className="App min-h-screen bg-citirex-bg text-citirex-ink">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/performance" element={<Performance />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/verticals/:slug" element={<VerticalPage />} />

          <Route path="/case-studies" element={<CaseStudiesIndex />} />
          <Route path="/case-studies/:slug" element={<CaseStudyPage />} />
          <Route path="/insights" element={<BlogIndex />} />
          <Route path="/insights/:slug" element={<BlogPost />} />

          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/ccpa-opt-out" element={<CCPA />} />

          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
